export const ES_EVENTS = {
  FOCUS_REPLY_TEXTAREA: 'FOCUS_REPLY_TEXTAREA',
};
